export enum UpdateDeviceActionTypes {
  OPEN_UPDATE_DEVICE_MODAL = 'OPEN_UPDATE_DEVICE_MODAL',
  CLOSE_UPDATE_DEVICE_MODAL = 'CLOSE_UPDATE_DEVICE_MODAL',
  NOTES_UPDATE = 'ON_NOTES_UPDATE',
  ORGANIZATION_UPDATE = 'ON_ORGANIZATION_UPDATE',
  UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST',
  UPDATE_DEVICE_SUCCEEDED = 'UPDATE_DEVICE_SUCCEEDED',
  UPDATE_DEVICE_FAILED = 'UPDATE_DEVICE_FAILED',
}

export interface OpenUpdateDeviceModal {
  type: UpdateDeviceActionTypes.OPEN_UPDATE_DEVICE_MODAL;
  payload;
}

export interface CloseUpdateDeviceModal {
  type: UpdateDeviceActionTypes.CLOSE_UPDATE_DEVICE_MODAL;
}

export interface NotesUpdate {
  type: UpdateDeviceActionTypes.NOTES_UPDATE;
  changedNotes: string;
}

export interface OrganizationUpdate {
  type: UpdateDeviceActionTypes.ORGANIZATION_UPDATE;
  changedOrganization: string;
}

export interface UpdateDeviceRequest {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST;
  input: object;
}

export interface UpdateDeviceSucceeded {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCEEDED;
  newDevice: object;
}

export interface UpdateDeviceFailed {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_FAILED;
  error: string;
}

export type UpdateDeviceActions =
  | OpenUpdateDeviceModal
  | CloseUpdateDeviceModal
  | NotesUpdate
  | OrganizationUpdate
  | UpdateDeviceRequest
  | UpdateDeviceSucceeded
  | UpdateDeviceFailed;

export function openUpdateDeviceModal(payload): OpenUpdateDeviceModal {
  return {
    type: UpdateDeviceActionTypes.OPEN_UPDATE_DEVICE_MODAL,
    payload,
  };
}

export function closeUpdateDeviceModal(): CloseUpdateDeviceModal {
  return {
    type: UpdateDeviceActionTypes.CLOSE_UPDATE_DEVICE_MODAL,
  };
}

export function notesUpdate(changedNotes: string): NotesUpdate {
  return {
    type: UpdateDeviceActionTypes.NOTES_UPDATE,
    changedNotes,
  };
}

export function organizationUpdate(changedOrganization: string): OrganizationUpdate {
  return {
    type: UpdateDeviceActionTypes.ORGANIZATION_UPDATE,
    changedOrganization,
  };
}

export function updateDeviceRequest(input: object): UpdateDeviceRequest {
  return {
    type: UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST,
    input,
  };
}

export function updateDeviceSucceeded(newDevice: object): UpdateDeviceSucceeded {
  return {
    type: UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCEEDED,
    newDevice,
  };
}

export function updateDeviceFailed(error: string): UpdateDeviceFailed {
  return {
    type: UpdateDeviceActionTypes.UPDATE_DEVICE_FAILED,
    error,
  };
}
